var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"white"},[_c('v-col',{attrs:{"md":"12","sm":"12"}},[_c('h1',{staticClass:"text-center"},[_c('strong',[_vm._v(_vm._s(_vm.title))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }